import { render } from "./PeopleMediumDevice.vue?vue&type=template&id=fbdd1f6e&scoped=true"
import script from "./PeopleMediumDevice.vue?vue&type=script&lang=js"
export * from "./PeopleMediumDevice.vue?vue&type=script&lang=js"

import "./PeopleMediumDevice.vue?vue&type=style&index=0&id=fbdd1f6e&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdd1f6e"]])

export default __exports__